/* eslint-disable indent */
import { buildCurrentUserResponseOrEmpty, } from '../cross-session/CadPiiCurrentUserResponse';
import { buildRefCodeDataOrEmpty } from '../cross-session/RefCodeData';
import { buildWwwHeartbeatOrEmpty } from '../cross-session/WwwHeartbeatData';
import { buildContactFieldsFromEloquaData, buildContactFieldsOrEmpty, } from './ContactFields';
import { buildPersistedProgressiveProfileOrEmpty, } from './PersistedProgressiveProfile';
import { buildSignupDecorationOrUndefined } from './SignupDecoration';
const personalizationProfileVersion = 4;
export const buildPersonalizationProfileOrEmpty = (data) => {
    if (!data) {
        return {
            contactFields: buildContactFieldsOrEmpty({}),
            currentUserData: buildCurrentUserResponseOrEmpty({}),
            heartbeatData: buildWwwHeartbeatOrEmpty({}),
            refCodeData: buildRefCodeDataOrEmpty({}),
            firstLandingPageDecoration: '',
            lastLandingPageDecoration: '',
            persistedProgressiveProfile: buildPersistedProgressiveProfileOrEmpty({}),
            signupDecoration: buildSignupDecorationOrUndefined({}),
            lastPushedDecorationsDateAdded: 0,
            lastPushedDecorations: {},
            lastUpdated: 0,
            hasLoggedIn: false,
            version: personalizationProfileVersion,
        };
    }
    return {
        contactFields: buildContactFieldsOrEmpty(data.contactFields),
        currentUserData: buildCurrentUserResponseOrEmpty(data.currentUserData),
        heartbeatData: buildWwwHeartbeatOrEmpty(data.heartbeatData),
        refCodeData: buildRefCodeDataOrEmpty(data.refCodeData),
        firstLandingPageDecoration: data.firstLandingPageDecoration || '',
        lastLandingPageDecoration: data.lastLandingPageDecoration || '',
        persistedProgressiveProfile: buildPersistedProgressiveProfileOrEmpty(data.persistedProgressiveProfile),
        signupDecoration: buildSignupDecorationOrUndefined(data.signupDecoration),
        lastPushedDecorations: data.lastPushedDecorations,
        lastPushedDecorationsDateAdded: data.lastPushedDecorationsDateAdded || 0,
        lastUpdated: Date.now(),
        hasLoggedIn: data.hasLoggedIn || false,
        version: personalizationProfileVersion,
    };
};
export const buildFromStoredOrCrossSession = ({ fromStorage, fromCrossSession, }) => {
    const { user: newUser, heartbeat: newHeartbeat } = fromCrossSession;
    const newContactFields = (newUser === null || newUser === void 0 ? void 0 : newUser.eloquaExtraData) ?
        buildContactFieldsFromEloquaData(newUser.eloquaExtraData)
        : fromStorage === null || fromStorage === void 0 ? void 0 : fromStorage.contactFields;
    const newCurrentUserData = (newUser === null || newUser === void 0 ? void 0 : newUser.cadPiiCurrentUserResponse) ?
        newUser.cadPiiCurrentUserResponse
        : fromStorage === null || fromStorage === void 0 ? void 0 : fromStorage.currentUserData;
    const newSignupDecoration = (newUser === null || newUser === void 0 ? void 0 : newUser.signupDecoration) ?
        buildSignupDecorationOrUndefined(newUser.signupDecoration)
        : fromStorage === null || fromStorage === void 0 ? void 0 : fromStorage.signupDecoration;
    const newRefCodeData = (newUser === null || newUser === void 0 ? void 0 : newUser.refCodeData) ? buildRefCodeDataOrEmpty(newUser.refCodeData) : fromStorage === null || fromStorage === void 0 ? void 0 : fromStorage.refCodeData;
    const profileToStore = buildPersonalizationProfileOrEmpty(Object.assign(Object.assign({}, fromStorage), { contactFields: newContactFields, currentUserData: newCurrentUserData, signupDecoration: newSignupDecoration, refCodeData: newRefCodeData, heartbeatData: newHeartbeat ? newHeartbeat : fromStorage === null || fromStorage === void 0 ? void 0 : fromStorage.heartbeatData }));
    return profileToStore;
};
